export const getBrowserSignature = (_) => {
	const windowObj = window || global;
	const base = 36;

	// Count Browser window object keys
	const windowObjCount = (_) => {
		const keys = [];
		for (const i in windowObj) {
			keys.push(i);
		}
		return keys.length.toString(base);
	};

	// window obj and navigator aggregate
	const pad = (str, size) => {
		return (new Array(size + 1).join('0') + str).slice(-size);
	};

	// Browser mimiTypes and User Agent count
	const navi = (
		navigator.mimeTypes.length + navigator.userAgent.length
	).toString(base);
	const padString = pad(navi + windowObjCount(), 4);

	// Browser screen specific properties
	const width = windowObj.screen.width.toString(base);
	const height = windowObj.screen.height.toString(base);
	const availWidth = windowObj.screen.availWidth.toString(base);
	const availHeight = windowObj.screen.availHeight.toString(base);
	const colorDepth = windowObj.screen.colorDepth.toString(base);
	const pixelDepth = windowObj.screen.pixelDepth.toString(base);

	// Base64 encode
	const signatureKey = btoa(
		padString +
			width +
			height +
			availWidth +
			availHeight +
			colorDepth +
			pixelDepth
	);

	return {
		signatureKey,
		colorDepth: parseInt(colorDepth, base),
		height: parseInt(height, base),
		width: parseInt(width, base),
		userAgent: navigator.userAgent,
		language: navigator.language,
		isJavaEnabled: navigator.javaEnabled()
	};
};
